import { useQuery } from 'react-query';

import { useSessionStore } from 'session/useSessionStore';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { axios } from 'configurations/axios';

export interface IBandInfo {
    index: number;
    minSampleValue: number;
    maxSampleValue: number;
}

export interface IFileInfo {
    width: number;
    height: number;
    bands: IBandInfo[];
}

export interface IFilePathAndInfo {
    Width: number;
    Height: number;
    FilePath: string;
}

export function useGetFileInfo(fileName: string | (string | null)[] | null) {
    const { tenantConfig, jwtToken } = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration,
        jwtToken: state.jwtToken
    }));

    return useQuery<IFileInfo>(['getFileInfo', fileName], async () => {
        const response = await axios.get<IResponseAPI<IFileInfo>>(
            `${tenantConfig?.endpoints.render}/FilesViewer/GetFileInfo?fileName=${fileName}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`
                },
            }
        );
        return response.data.Result ?? response.data;
    }, {
        refetchOnWindowFocus: false,
        enabled: fileName !== null && fileName !== undefined && fileName !== '',
    });
}

export function useGetFilePathAndInfo(fileToken: string | (string | null)[] | null, execute: boolean) {
    const { tenantConfig, jwtToken } = useSessionStore(state => ({
        tenantConfig: state.tenantConfiguration,
        jwtToken: state.jwtToken
    }));

    return useQuery<IFilePathAndInfo>(['getFilePathAndInfo', fileToken], async () => {
        const response = await axios.get<IResponseAPI<IFilePathAndInfo>>(
            `${tenantConfig?.endpoints.fileIndexing}/FileManager/FileManager/GetFilePathAndInfo?fileToken=${fileToken}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`
                },
            }
        );
        return response.data.Result;
    }, {
        refetchOnWindowFocus: false,
        enabled: fileToken !== null && fileToken !== undefined && fileToken !== '' && execute,
    });
}
